module.exports = __webpack_public_path__ + "media/images/dave-f0b5cc891b65c951d13466262dd083a3.jpg";